// PowerSync — тесты, попытки, drafts.
//
// Local*-типы — РЕАЛЬНЫЕ колонки БД (information_schema):
//   attempt_drafts: started_at/last_saved_at (нет created_at/updated_at)
//   attempt_records: score/correct_count/total_count/time_taken_sec/
//                    submitted_at (нет score_percent/duration_sec/completed_at)
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalAttemptDraft {
	id: string;
	test_id: string;
	user_id: string;
	current_question_idx: number;
	partial_answers: string | null; // jsonb
	partial_confidence_ratings: string | null; // jsonb
	time_used_sec: number;
	status: string;
	started_at: string;
	last_saved_at: string | null;
}

export interface LocalAttemptRecord {
	id: string;
	test_id: string;
	user_id: string;
	score: number;
	correct_count: number;
	total_count: number;
	time_taken_sec: number;
	answers: string | null; // jsonb
	confidence_ratings: string | null; // jsonb
	passed: number; // bool
	breakdown_by_topic: string | null; // jsonb
	status: string;
	created_at: string;
	submitted_at: string | null;
}

export function useAttemptDraftQuery(testId: string | undefined, userId: string | undefined) {
	return usePowerSyncQuery<LocalAttemptDraft>(
		`SELECT * FROM attempt_drafts
		   WHERE test_id = ? AND user_id = ? AND status = 'in-progress'`,
		[testId ?? "", userId ?? ""],
	);
}

/** Одна попытка по id — офлайн-источник для экрана результатов. */
export function useAttemptRecordQuery(attemptId: string | undefined) {
	return usePowerSyncQuery<LocalAttemptRecord>(
		`SELECT * FROM attempt_records WHERE id = ? LIMIT 1`,
		[attemptId ?? ""],
	);
}

export function useAttemptRecordsQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalAttemptRecord>(
		`SELECT * FROM attempt_records
		   WHERE user_id = ?
		ORDER BY submitted_at DESC`,
		[userId ?? ""],
	);
}
